import { render, staticRenderFns } from "./Antipanic.vue?vue&type=template&id=023366e8"
import script from "./Antipanic.vue?vue&type=script&lang=js"
export * from "./Antipanic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports